import { createFileRoute, redirect } from "@tanstack/react-router";

/** Merged into the « Suivi financier » page — kept so old links still land. */
export const Route = createFileRoute("/_authed/_dashboard/admin-tools/payment-orders")({
  beforeLoad: () => {
    throw redirect({ to: "/admin-tools/finance", search: { tab: "orders" } });
  },
});
